import { Sort, SortDirection } from 'lib-shared-types-api';

/** Gets the sort object from a delimited sort string. */
export function getSortObjectFromString<TSortKey extends string>(
  sortParam: string,
  sortKeys?: readonly TSortKey[],
): Sort<TSortKey> | undefined {
  const [key, direction] = sortParam.split(':') as [
    TSortKey | undefined,
    SortDirection | undefined,
  ];

  const isValidKey = key && !!sortKeys?.includes(key);
  const isValidDirection =
    typeof direction === 'undefined' ||
    (direction && (direction === 'asc' || direction === 'desc'));

  if (isValidKey) {
    return {
      key,
      ...(isValidDirection ? { direction } : {}),
    };
  }
}
